import { useEffect, useState } from "react";

export default function CountdownTimer({ deadline, active }) {
  const [t, setT] = useState({ d: 0, h: 0, m: 0, s: 0, done: false });

  useEffect(() => {
    const target = new Date(deadline).getTime();
    const tick = () => {
      const now = Date.now();
      const diff = target - now;
      if (diff <= 0) { setT({d:0,h:0,m:0,s:0,done:true}); return; }
      const d = Math.floor(diff/86400000);
      const h = Math.floor((diff%86400000)/3600000);
      const m = Math.floor((diff%3600000)/60000);
      const s = Math.floor((diff%60000)/1000);
      setT({d,h,m,s,done:false});
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [deadline]);

  if (!active || t.done) {
    return <div className="chip text-amber-300 border-amber-400/40 bg-amber-400/10">Early Bird Closed</div>;
  }

  const Box = ({v,l}) => (
    <div className="flex flex-col items-center bg-white/[0.03] border border-cyan-400/20 rounded-xl px-3 py-2 min-w-[64px]">
      <div className="text-2xl font-bold text-white tabular-nums">{String(v).padStart(2,"0")}</div>
      <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">{l}</div>
    </div>
  );

  return (
    <div data-testid="countdown-timer" className="flex items-center gap-2">
      <Box v={t.d} l="days"/>
      <span className="text-cyan-400 text-lg">:</span>
      <Box v={t.h} l="hrs"/>
      <span className="text-cyan-400 text-lg">:</span>
      <Box v={t.m} l="min"/>
      <span className="text-cyan-400 text-lg">:</span>
      <Box v={t.s} l="sec"/>
    </div>
  );
}
